// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__35sj5","checkboxCol":"Table_checkboxCol__3qq8i","emailCol":"Table_emailCol__jy5VI","actionCol":"Table_actionCol__yGGT_"};